<template>
    <div>
        <b-modal 
            v-model="modal.verifyModal"
            stacking
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-footer
            size="lg"
            @hidden="reset()"
        >
            <template slot="modal-title">
                <div slot="header" class="bg-white border-0">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="mb-1"> ยืนยันตัวตน </h3>
                            <b-badge :variant="statusCommission( statusVerify.status ).color +' report'" >
                                {{ statusCommission( statusVerify.status ).status }}
                            </b-badge>
                            <label class="px-2 text-muted">{{statusVerify.remark == '-' ? '' : statusVerify.remark}}</label>
                        </div>
                    </div>
                </div>
            </template>
            <card shadow type="secondary" class="m--4">
                <formVerify
                    :submitForm.sync="submitForm"
                    :data="data" 
                    :account="account"
                    :images="images"
                    :tabKey.sync="tabKey"
                    typeFormTab="commission"
                    ref="verify"
              
                />
                <div class="mt-4 w-100 text-right">
                    <b-button variant="secondary" @click="reset()">{{ btnCancelRegister.txt }}</b-button>
                    <b-button 
                        v-if="btnConfirmRegister.show" 
                        type="submit" 
                        variant="success" 
                        @click="beforeSubmit()"
                    >
                        ยืนยัน
                    </b-button>
                </div>
            </card>
        </b-modal>
    </div>
</template>
<script>
import validatePop from "@/plugins/validatePop.js"
import formVerify from '@/components/custom/brance/FormVerify'
import configRegisterCommission from '@/config/RegisterCommission'
import { statusCommission } from "../../../plugins/statusCommission.js"
const API_URL = process.env.VUE_APP_API;
export default {
    name: "VerifyShop" ,
    components: {
        formVerify
    },
    props: {
        modal: Object,
        loading: Boolean,
        statusVerify: Object,
        shippop:Object
    },
    data() {
        return {
            submitForm: false,
            tabKey:'person',
            data:{
                name_title: "",
                tax_id: "",
                laser_code: "",
                date_birthday: "",
                date_expiry: "",
                email: "",
                name: "",
                address: "",
                state: "",
                district: "",
                province: "",
                postcode: "",
                tel: "",
                errorTax: false,
            },
            account: [{
                account_id: '',
                account_name: '',
                account_branch: '',
                account_bank: '',
                branch_code: '',
            }],
            images:[
                {
                    name:'image_card_front',
                    lable:'รูปภาพบัตรประชาชนด้านหน้า',
                    file:null,
                    preview:"",
                },
                {
                    name:'image_card_back',
                    lable:'รูปภาพบัตรประชาชนด้านหลัง',
                    file:null,
                    preview:"",
                },
                {
                    name:'image_card',
                    lable:'รูปถ่ายยืนยันตัวตนคู่กับบัตรประชาชน', 
                    file:null,
                    preview:"", 
                },
                {
                    name:'image_account',
                    lable:'รูปภาพสมุดบัญชี',
                    file:null,
                    preview:"",
                },
            ],
            statusCommission: statusCommission,
            configStatus: configRegisterCommission.statusRegister
        }
    },
    methods: {
        beforeSubmit(){
            let status = this.statusVerify.status
            let configStatus = configRegisterCommission.statusRegister
            if( !this.validateFormVerify() ){
                return false
            }
            if( [configStatus.REJECT_BY_SP , configStatus.REJECT_BY_SA].includes(status) ){
                this.updateDataRegisterCommission()

            }else if( status == configStatus.NOT_REGISER_YET ){
                if( this.shippop == undefined ){
                    this.create()
                }else{
                    this.createByShippop()
                }

            }else{
            }
        },
        async getDetailsRegister(){

            this.$emit('update:loading', true)

            await this.$http.get( this.$API_URL + "/shop/register/commission" , { 
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }).then( response => {

                let res = response.data
                this.setDataRegister( res )
                this.$emit('update:loading', false)

            })

        },
        setDataRegister( data ){

            this.tabKey = data.customer_type
            this.data.name_title = this.setNameTitle( data.name_title )
            this.data.tax_id = data.card_id
            this.data.laser_code = data.laser_code
            this.data.date_birthday = data.date_birthday
            this.data.date_expiry = data.card_expire
            this.data.email = data.email
            this.data.name = data.name
            this.data.address = data.address
            this.data.state = data.state
            this.data.district = data.district
            this.data.province = data.province
            this.data.postcode = data.postcode
            this.data.tel = data.tel
            this.account[0].account_id = data.account.account_id
            this.account[0].account_name = data.account.account_name
            this.account[0].account_branch = data.account.account_branch
            this.account[0].account_bank = data.account.account_bank
            this.account[0].branch_code = data.account.branch_code

            let changeKeyImageStrToNumber = Object.keys( data.images )
            this.images.forEach( (item , index) => {
                if( this.tabKey == 'person'){
                    if(item.name == 'image_tax_front'){
                        item.preview = data.images['image_card_front']
                        item.file = item.name
                    }else if(item.name == 'image_tax_double') {
                        item.preview = data.images['image_card']
                        item.file = item.name
                    }else if(item.name == 'image_account') {
                        item.preview = data.images['image_account']
                        item.file = item.name
                    }
                }else{
                    this.images[index].preview = data.images[ changeKeyImageStrToNumber[index] ]
                    this.images[index].file = this.images[index].name
                }
            }); 
        },
        setNameTitle( title ){

            let titleName = configRegisterCommission.ListTitleName
            return titleName.find( ( value ) => {
                return value.nameTitle == title
            })

        },
        validateFormVerify(){

            this.submitForm = true
            this.$refs.verify.$v.$touch()
            if ( this.$refs.verify.$v.$invalid ){

                return false

            }

            return true

        },
        updateDataRegisterCommission(){
            this.$emit('update:loading', true)
            this.$http.put( this.$API_URL + "/shop/register/commission" , {
                    email: this.data.email,
                    laser_code: this.data.laser_code,
                    card_id: this.data.tax_id,
                    tel: this.data.tel,
                    account: this.account,
                    date_birthday: this.data.date_birthday,
                    card_expire: this.data.date_expiry,
                    name_title: this.data.name_title.nameTitle,
                    name: this.data.name,
                    address: this.data.address,
                    state: this.data.state,
                    district: this.data.district,
                    province: this.data.province,
                    postcode: this.data.postcode,
                    customer_type: this.$refs.verify.tabKey,
                    images: this.changeImageByType(),
                    type: this.$refs.verify.tabKey
                },
                {
                    headers:{
                     Token: localStorage.getItem("access_token")
                }
            }).then( response => {

                let checkError = validatePop( response )

                    if( !checkError.status ){

                        this.$emit( 'update:loading', false )
                        this.showErrorModal( checkError.msg )
                        return false

                    }

                let res = response.data.data

                this.statusVerify.status = String(res.status)
                this.$emit( 'update:loading', false )
                this.showSuccessModal("แก้ไขข้อมูลสำเร็จ")
                this.reset()

            })

        },
        createByShippop(){
            if( this.account[0].branch_code.length == 3 ){
                this.account[0].branch_code = "0"+this.account[0].branch_code
            }

            this.$emit('update:loading', true)
            this.$http
                .post(
                    API_URL + `${this.shippop.url}`,
                    {
                        id: this.shippop.id,
                        type: this.shippop.type,
                        email: this.data.email,
                        laser_code: this.data.laser_code,
                        card_id: this.data.tax_id,
                        tel: this.data.tel,
                        account: this.account,
                        date_birthday: this.data.date_birthday,
                        card_expire: this.data.date_expiry,
                        name_title: this.data.name_title.nameTitle,
                        name: this.data.name,
                        address: this.data.address,
                        state: this.data.state,
                        district: this.data.district,
                        province: this.data.province,
                        postcode: this.data.postcode,
                        customer_type: this.$refs.verify.tabKey,
                        ...( ( this.$refs.verify.tabKey == 'person' ) ? { 
                            images: JSON.stringify({
                                image_card_front: this.images[0].preview ,
                                image_card: this.images[2].preview,
                                image_account: this.images[3].preview
                            }),
                        } : {
                            images: JSON.stringify({
                                image_company_certificate: this.images[0].preview ,
                                image_certified_of_vat: this.images[1].preview,
                                image_business_account: this.images[2].preview,
                            }),
                        } ),   
                    },
                    {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    let checkError = validatePop( res )

                    if( !checkError.status ){
                        this.handleLoader()
                        this.showErrorModal( checkError.msg )
                        return false
                    }
                    this.showSuccessModal("สมัครสมาชิกสำเร็จ")
                    this.reset()
                    this.$emit('reloadByShippop');
                })
        },
        create(){
    
            if( this.account[0].branch_code.length == 3 ){
                this.account[0].branch_code = "0"+this.account[0].branch_code
            }

            this.$emit('update:loading', true)
            this.$http
                .post(
                    API_URL + "/shop/register/commission",
                    {
                        email: this.data.email,
                        laser_code: this.data.laser_code,
                        card_id: this.data.tax_id,
                        tel: this.data.tel,
                        account: this.account,
                        date_birthday: this.data.date_birthday,
                        card_expire: this.data.date_expiry,
                        name_title: this.data.name_title.nameTitle,
                        name: this.data.name,
                        address: this.data.address,
                        state: this.data.state,
                        district: this.data.district,
                        province: this.data.province,
                        postcode: this.data.postcode,
                        customer_type: this.$refs.verify.tabKey,
                        ...( ( this.$refs.verify.tabKey == 'person' ) ? { 
                            images: JSON.stringify({
                                image_card_front: this.images[0].preview ,
                                image_card: this.images[2].preview,
                                image_account: this.images[3].preview
                            }),
                        } : {
                            images: JSON.stringify({
                                image_company_certificate: this.images[0].preview ,
                                image_certified_of_vat: this.images[1].preview,
                                image_business_account: this.images[2].preview,
                            }),
                        } ),   
                        type: this.$refs.verify.tabKey
                    },
                    {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        }
                    }
                )
                .then(res => {
                    let checkError = validatePop( res )

                    if( !checkError.status ){
                        this.handleLoader()
                        this.showErrorModal( checkError.msg )
                        return false
                    }

                    this.statusVerify.status = String( res.data.data.status )
                    this.handleLoader()
                    this.showSuccessModal("สมัครสมาชิกสำเร็จ")
                    this.reset()
                })
        },
        changeImageByType(){

            if( this.$refs.verify.tabKey == 'person' ){

                return JSON.stringify({
                    image_card_front: this.images[0].preview ,
                    image_card: this.images[2].preview,
                    image_account: this.images[3].preview
                })

            }else{

                return JSON.stringify({
                    image_company_certificate: this.images[0].preview ,
                    image_certified_of_vat: this.images[1].preview,
                    image_business_account: this.images[2].preview
                })
            }

        },
        handleLoader(){
            this.$emit('update:loading', !this.loading);
        },
        reset(){
            Object.keys(this.data).forEach(key => {
                this.data[key] = ""
            });
            this.account = [{
                account_id: '',
                account_name: '',
                account_branch: '',
                account_bank: '',
                branch_code: '',
            }];
            this.images.forEach(( item , index ) => {
                this.images[index].file = null;
                this.images[index].preview = "";
            });
            this.submitForm = false
            this.modal.verifyModal = false
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "SUCCESS",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ตกลง",
                contentClass: "modal-success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: OkmsgTitle,
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
    },
    computed:{

        statusRegister(){

            return String( this.statusVerify.status )

        },
        btnConfirmRegister(){

            let details = { show: true }

            if( [this.configStatus.WAIT_SA , this.configStatus.WAIT_SP , this.configStatus.WAIT_DOC , this.configStatus.SUCCESS]
                .includes(this.statusRegister) 
            ){

                details.show = false

            }

            return details
        },
        btnCancelRegister(){

            let details = { txt: "ยกเลิก" }

            if( [this.configStatus.WAIT_SA , this.configStatus.WAIT_SP , this.configStatus.WAIT_DOC , this.configStatus.SUCCESS]
                .includes(this.statusRegister) 
            ){

                details.txt = "ปิด"

            }

            return details
        }
    },
    watch: {
        "modal.verifyModal": function ( statusShow ){

            let status = this.statusVerify.status

            if( statusShow == true && ![String(null) , null].includes(status) ){
                
                this.getDetailsRegister()

            }

        }
            
    }
}
</script>